module.exports = __webpack_public_path__ + "img/frame (73).7faadcb8.jpg";